
import { Outlet } from "react-router-dom";
import Header from "./Header";
import '../styles/global.scss'
import Footer from "./Footer";
import { useState } from "react";

export default function Layout(){
    const [theme, setTheme] = useState('dark');
    const onThemeChange = (userTheme) => {
        setTheme(userTheme)
    }
    return(
        <>
            <Header onThemeChange={onThemeChange} />
            <Outlet context={[theme]} />
            <Footer/>
        </>
    )
}